var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeTruckBPi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 16H11V12C11 11.4487 10.5513 11 10 11V9C11.6543 9 13 10.3457 13 12V16Z",
    fill: "#F48000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 16H15V12C15 10.3457 16.3457 9 18 9V11C17.4487 11 17 11.4487 17 12V16Z",
    fill: "#F48000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 19H25.4648C25.7992 19 26.1114 19.1671 26.2969 19.4453L28 22H22V19Z",
    fill: "#F48000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 30C11.1046 30 12 29.1046 12 28C12 26.8954 11.1046 26 10 26C8.89543 26 8 26.8954 8 28C8 29.1046 8.89543 30 10 30Z",
    fill: "#F48000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21 25.7803V18C21 17.4477 20.5523 17 20 17H5C4.44769 17 4 17.4477 4 18V27C4 27.5523 4.44769 28 5 28H7C7 26.3457 8.3457 25 10 25C11.6543 25 13 26.3457 13 28H20C20 27.1168 20.3907 26.3298 21 25.7803Z",
    fill: "#F48000"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 23V25.1843C22.3143 25.0722 22.6476 25 23 25C24.6543 25 26 26.3457 26 28H27C27.5523 28 28 27.5523 28 27V23H22Z",
    fill: "#F48000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23 30C24.1046 30 25 29.1046 25 28C25 26.8954 24.1046 26 23 26C21.8954 26 21 26.8954 21 28C21 29.1046 21.8954 30 23 30Z",
    fill: "#F48000"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19 6V11C19 11.5523 19.4477 12 20 12H21V9C21 8.44771 21.4477 8 22 8H26C26.5523 8 27 8.44771 27 9V12H28C28.5523 12 29 11.5523 29 11V6H19Z",
    fill: "#F48000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22 9H26V12H22V9Z",
    fill: "#F48000"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H30L24.4472 2.1099C24.1657 1.96337 23.8343 1.96337 23.5528 2.1099L18 5Z",
    fill: "#F48000"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 7C6.88071 7 8 5.88071 8 4.5C8 3.11929 6.88071 2 5.5 2C4.11929 2 3 3.11929 3 4.5C3 5.88071 4.11929 7 5.5 7Z",
    fill: "#F48000"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12H3C2.44772 12 2 11.5523 2 11V10C2 8.34315 3.34315 7 5 7H6C7.65685 7 9 8.34315 9 10V11C9 11.5523 8.55229 12 8 12Z",
    fill: "#F48000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeTruckBPi);
export default __webpack_public_path__ + "static/media/home_truck_BPi.c1202113df8aa30632d82be325bd3424.svg";
export { ForwardRef as ReactComponent };